import { createI18n } from 'vue-i18n'

import zh_CN from './zh.js'
import en from './en.js'

import common_zh_CN from './common/zh_CN.js'
import common_en from './common/en.js'

// 语言库
const messages = {
    'zh_CN': zh_CN,
    'en': en
}
const commonMessages = {
    'zh_CN': common_zh_CN,
    'en': common_en
}

function loadLocaleMessages() {
    // 读取pages页面下，每个模块下的国际化文件
    const requireContextPages = require.context('../../pages', true, /language\/.*\.js$/);
    const localeMessages = {};
    requireContextPages.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            localeMessages[locale] = Object.assign({}, localeMessages[locale], requireContextPages(key).default );
        }
    });
    // 合并国际化文件
    for (const messagesKey in messages) {
        messages[messagesKey] = Object.assign({}, messages[messagesKey], commonMessages[messagesKey], localeMessages[messagesKey]);
    }
    return messages;
}
const localeMesssages = loadLocaleMessages()
// 默认语言
// const langDefault = 'zh-CN'
let languageI18n = localStorage.getItem("language") || 'zh_CN'
const i18n = createI18n({
    globalInjection: true,
    legacy: false,
    locale: languageI18n,		//默认显示的语言
    messages: localeMesssages
})
export const currentLanguageObject = localeMesssages[languageI18n]
export default i18n; // 将i18n暴露出去，在main.js中引入挂载
